import React from 'react';
import { motion } from 'framer-motion';
export function Contact() {
  return <section id="contact" className="py-32 md:py-48 border-t border-border" data-id="element-107">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="glass-card p-12 md:p-16 rounded-3xl text-center" data-id="element-109">
          <h2 className="text-3xl md:text-5xl font-bold text-primary tracking-tight mb-6" data-id="element-110">
            Measuring what your AI is actually worth?
          </h2>

          <p className="text-lg md:text-xl text-secondary leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-111">
            If you are building product around marketing measurement,
            experimentation, or the decision systems that sit on top of AI,
            let's talk.
          </p>

          <div className="mb-12" data-id="element-112">
            <a href="mailto:karan.dhir@outlook.com" className="inline-flex items-center justify-center px-8 py-4 text-sm font-semibold text-dark bg-gold hover:bg-gold-hover rounded-full transition-colors" data-id="element-113">
              Get in Touch
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-114">
            <a href="https://www.linkedin.com/in/dhirkaran/" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors font-medium" data-id="element-115">
              LinkedIn
            </a>
            <span className="hidden sm:block text-border" data-id="element-116">•</span>
            <a href="https://substack.com/@karandhir" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors font-medium" data-id="element-117">
              Substack
            </a>
            <span className="hidden sm:block text-border" data-id="element-118">•</span>
            <a href="https://github.com/kd-511" target="_blank" rel="noopener noreferrer" className="text-secondary hover:text-primary transition-colors font-medium" data-id="element-119">
              GitHub
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}